// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aTk5","col":"styles_col__3l5pf"};